import { useEffect, useState } from 'react';

// This hook returns true/false based on whether the user has reached the end of target element plus threshold
const useElementEndReached = ({
  scrollableElementRef,
  targetRef,
  threshold = 100,
}) => {
  const [isEndReached, setIsEndReached] = useState(false);

  useEffect(() => {
    const scrollableElement = scrollableElementRef?.current || null;
    // target is element we are tracking the end of (e.g. content section)
    const target = targetRef?.current || null;

    if (!scrollableElement) return;

    if (!target) {
      setIsEndReached(true);
      return;
    }

    const update = () => {
      const targetRect = target.getBoundingClientRect();
      const scrollableRect = scrollableElement.getBoundingClientRect();

      const targetBottom =
        targetRect.bottom - scrollableRect.top + scrollableElement.scrollTop;

      const scrollPosition =
        scrollableElement.scrollTop + scrollableElement.clientHeight;

      setIsEndReached(scrollPosition >= targetBottom + threshold);
    };

    update();
    scrollableElement.addEventListener('scroll', update, { passive: true });
    return () => scrollableElement.removeEventListener('scroll', update);
  }, [scrollableElementRef, targetRef, threshold]);

  return {
    isElementEndReached: isEndReached,
  };
};

export default useElementEndReached;
